<template>
  <div class="col-sm-12 col-md">
    <InputWidget
      v-model="model"
      :error="errors"
      id="input-title"
      type="select"
      @change="inputChange"
      @input="onInput"
      :label="computedLabel"
      :placeholder="computedPlaceholder"
      :rules="required ? 'required' : ''"
      :options="signupTitleOptions"
    />
  </div>
</template>

<script>
import BaseInputMixin from "../../../../mixins/signupInputMixin";
import InputWidget from "../../../core/InputWidget";
import {mapGetters} from "vuex";

export default {
  name: "Title",
  components: {InputWidget},
  mixins: [BaseInputMixin('title')],

  data() {
    return {
      defaultLabel: this.$t("Title",)
    }
  },
  computed: {
    ...mapGetters(["signupTitleOptions"]),
  }
}
</script>

<style scoped>

</style>
